import config from '@/config';
import { DetailedAddress, DetailedCommercialAddress } from '@/types/api/tenants';
import { SyncDetailedAddress } from '@/types/api/sync';
import { stringify } from 'qs';
import http from '@/utils/http';
import { RENTAL_STATUS } from '@/constants/tenants';

export async function apiGetDetailedAddress(
  externalId: string,
  floors?: number[],
  sortByFloorOrder: boolean = true,
): Promise<DetailedAddress> {
  const response = await http.get<DetailedAddress>(
    `${config.apiUrl}userapi/integrations/tenant-integration/detailed-address`,
    {
      params: {
        externalId: externalId,
        floors: floors,
        sortByFloorOrder: sortByFloorOrder,
      },
      paramsSerializer: (params) => {
        return stringify(params, { arrayFormat: 'repeat' });
      },
    },
  );

  return response.data;
}

export async function apiGetDetailedCommercialAddress(
  externalId: string,
): Promise<DetailedCommercialAddress> {
  const response = await http.get<DetailedCommercialAddress>(
    `${config.apiUrl}userapi/integrations/tenant-integration/detailed-address`,
    {
      params: {
        externalId: externalId,
        addressType: 'corporate',
      },
      paramsSerializer: (params) => {
        return stringify(params, { arrayFormat: 'repeat' });
      },
    },
  );

  return response.data;
}

export async function apiGetSyncApartments(externalId: string): Promise<SyncDetailedAddress> {
  const response = await http.get<SyncDetailedAddress>(
    `${config.syncApiUrl}userapi/apartments/${externalId}`,
  );

  return {
    ...response.data,
    floors: response.data.floors.map((floor) => ({
      ...floor,
      apartments: floor.apartments.map((apartment) => ({
        ...apartment,
        rentalStatus: apartment.rentalStatus ?? RENTAL_STATUS.RENTED,
      })),
    })),
  };
}
